import { PlanFeature, PlanFeatureInformationVO, PlanFeatureModel } from '@um/uptime-monitoring-shared';

export const getFeatureInformation = (featureKey: PlanFeature, features: { [key: string]: PlanFeatureModel }): PlanFeatureInformationVO => {
  const feature = features[featureKey];

  return { key: featureKey, featureMissing: !feature, quota: feature?.quota };
};
